export default "__VITE_ASSET__BZHt6XLr__"